// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__2ujEa","footer":"style_footer__oyNEt","abort":"style_abort__3aSiF","saveChecklist":"style_saveChecklist__3vBxo","submit":"style_submit__1G7cC"};